import React from 'react';
import { Heading, Typography } from '@kiiwi/ui';
import { useTranslation, Trans } from '@/src/i18n';
import useResponsive from '@/src/hooks/useResponsive';

interface Props {
  titleKey: string;
  subtitleKey: string;
  rightSideElement?: React.ReactElement;
}
const ListHeader: React.FC<Props> = ({
  titleKey,
  subtitleKey,
  rightSideElement,
}) => {
  const { t } = useTranslation();
  const { isMobile } = useResponsive();

  const titleElement = (
    <Heading as="h2" variant="subtitle-1" className="text-neutral-primary">
      {t(titleKey)}
    </Heading>
  );

  return (
    <div className="mb-3 flex items-end justify-between">
      <div className="w-full">
        {isMobile && !!rightSideElement ? (
          <div className="flex items-center justify-between">
            {titleElement}
            {rightSideElement}
          </div>
        ) : (
          titleElement
        )}
        <Typography
          variant="body-1"
          className="flex flex-wrap whitespace-pre text-neutral-secondary"
        >
          <Trans
            i18nKey={subtitleKey}
            components={{ highlight: <span className="font-semibold" /> }}
          />
        </Typography>
      </div>
      {!isMobile && rightSideElement}
    </div>
  );
};

export default React.memo(ListHeader);
